import MessageEditor from './ui/MessageEditor';
import { decorators } from './constans/decorators';
import {
  inlineStyle,
  blockHeading,
  blockList,
  linkAdd,
  phoneAdd,
  initEditorLinkModalData,
  initEditorPhoneModalData,
  informationsLinkAdd,
  initEditorInformationsLinkModalData
} from './constans/controlToolbar';

export default MessageEditor;
export {
  decorators,
  inlineStyle,
  blockHeading,
  blockList,
  linkAdd,
  phoneAdd,
  initEditorLinkModalData,
  initEditorPhoneModalData,
  initEditorInformationsLinkModalData,
  informationsLinkAdd,
};
